import React from 'react'
import SkillsCards from './SkillsCards'
import '../css/Skills.css'

const Services = () => {
    const myServices = [
        { 
            "id": 1,
            "name": "Web Design",
            "description": "I will design your website for you.",
            "LanguageLogo": "" 
        },
        { 
            "id": 2,
            "name": "Web development",
            "description": "I will develop your website for you. Front-end (React) and Back-end (Flask)" ,
            "LanguageLogo": ""
        },
        { 
            "id": 3,
            "name": "Software Development",
            "description": "I will develop your desired app in Native language (Java) or Hybrid App (JavaScript).",
            "LanguageLogo": ""
        }

    ]

    

    return (
        <div className="skillsContainer" id="services">
           <div className="skillsHeader">
               <div className="skillsHeaderText">Services</div>
           </div>
           <div>
                <div className="skillsAllCardContainer">
                    <SkillsCards mySkills={myServices} isProjects={false} />
                </div> 
            </div>
        </div>
    )
}

export default Services
